import { BEHAVIORAL_HEALTH_ROLE, HEALTH_GUIDE_ROLE, MD_ROLE, NP_ROLE } from './careTeamRoles'

export const APPOINTMENT_TYPE_TO_ROLE = {
  behavioralHealth: [BEHAVIORAL_HEALTH_ROLE],
  healthGuideConsult: [HEALTH_GUIDE_ROLE],
  annualWellnessVisitEstablished: [NP_ROLE, MD_ROLE],
  annualWellnessVisitNew: [NP_ROLE, MD_ROLE],
  video: [NP_ROLE, MD_ROLE],
  videoNew: [NP_ROLE, MD_ROLE],
  focused: [NP_ROLE, MD_ROLE],
}
